export { default as Spinner } from './component';
